module.exports = require("@swissquote/crafty-commons/packages/end-of-stream.js");